import { SIZES as MODAL_SIZES } from "@kiwicom/orbit-components/src/Modal/consts";
import theme from "@kiwicom/orbit-components/lib/defaultTheme";
import * as React from 'react';
export default {
  MODAL_SIZES,
  theme,
  React
};